import { tmxApiCall } from './index'

// Utilities
import Logger from '../utility/loggerUtil'

export default {
  /**
   * Gets the global app configuration.
   * @returns {Promise<{appConfig: {sessionTimeOut: Number, paymentTimeOut: Number, refiPaymentTimeOut: Number, manageNotifications: Boolean, allowNoSsnRefi: Boolean, menuItemVisibility: Object, loanDocumentUploadSettings: Object, pastDuePhoneDayLimit: Object, canUploadTlxeLoanDocuments: boolean, disbursementMaxPollingAttempts: Number, canUseDisbursementPolling: Boolean, forceAddonGps: Boolean, forceRefiGps: Boolean, canSendVoiceMessages: Boolean, manualRetryConfig {enabled: Boolean, intervalInMinutes: Number}, autoPayStandardPayment: Boolean, autoPayRefi: Boolean, canUnitasCardCreate: Boolean, canRepayCardCreate: Boolean, displayDocumentUploadMenuItem: Boolean, canMigrateProfileToEmail: Boolean, updateUsernameInfo: {bannerTitle: String, bannerText: String, instructionText: String, skipButtonText: String}, canSkipMigrateProfileToEmail: Boolean, repayConfig: {BaseHeightPx: Number, ErrorHeightPx: Number}, autoPayReapply: Boolean}}>}
   */
  async getConfigSettings () {
    Logger.info('Started Get Config Settings query')
    return tmxApiCall('get', '/configsettings')
  },

  async getLmsReferenceIds () {
    Logger.info('Started Get LMS Reference Id query.')
    return tmxApiCall('get', '/lmsReferenceId')
  },

  async getContactUs () {
    Logger.info('Started Get Contact Us query.')
    return tmxApiCall('get', '/contacts')
  },

  /**
   * Gets the global service availability.
   * @returns {Promise<{available: Boolean}>}
   */
  async getServiceStatus () {
    Logger.info('Started Get Service Status')
    return tmxApiCall('get', '/serviceStatus')
  },

  async getProductConfiguration (state, productType, storeNumber) {
    Logger.info('Started Get Product Config Settings')
    return tmxApiCall('get', '/applicationProductConfig', {
      params: {
        state,
        productType,
        storeNumber
      }
    })
  },

  /**
   * Gets the product specific disclosure links.
   * @param {String} state - The state associated to the product to query for.
   * @param {String} productType - The product type associated to the product to query for (title or signature).
   * @param {String} disclosureType - The disclosure type associated to the product to query for.
   * @param {String|Number} storeNumber - The store number associated to the product to query for.
   * @returns {Promise<{disclosures: {label: string, url: string, description}[]}>}
   */
  async getDisclosures (state, productType, disclosureType, storeNumber) {
    return tmxApiCall('get', '/disclosure', {
      params: {
        applicationState: state,
        productType,
        disclosureType,
        storeNumber
      }
    })
  },

  async getVergentConfigurations () {
    // Placeholder until Vergent available
    return {
      raceConfigurations: [
        { value: '', text: '' },
        { value: '87', text: 'White / Caucasian' },
        { value: '88', text: 'Black / African American' },
        { value: '89', text: 'Hispanic' },
        { value: '90', text: 'Asian / Pacific Islander' },
        { value: '92', text: 'Native American Indian' },
        { value: '316', text: 'Other' }
      ]
    }
  }
}
